import BaseComponent from '../../BaseComponent';

export default class DiscussionCompletionConditions extends BaseComponent {

    public init(): void {
        if (this.options.isDisabled) {
            return;
        }

        const $inputs = this.$component.find('input[type="checkbox"]');
        const $readInput = this.$component.find('input[name="read_condition"]');
        const $videocallInput = this.$component.find('input[name="videocall_condition"]');
        const $form = this.$component.closest('form');
        const $topicSelect = $form.find('select[name="topic"]');

        let customReward: number = this.options.customReward;

        $form.on('change input', 'input[name="post_reward"]', (e) => {
            customReward = parseInt(e.currentTarget.value) || null;
        });

        $inputs.add($topicSelect).on('change', () => {
            const conditions: Record<string, boolean> = {};

            conditions['read'] = $readInput[0] && $readInput.is(':checked');
            conditions['videocall'] = $videocallInput[0] && $videocallInput.is(':checked');

            $inputs.each((index, element) => {
                if (element === $readInput[0] || element === $videocallInput[0]) {
                    return;
                }

                const $element = $(element);
                const name = $element.val();
                if (typeof name === 'string') {
                    conditions[name] = $element.is(':checked') && !conditions['read'];
                }
            });

            const data = {
                topicId: $topicSelect.val() !== '' ? parseInt($topicSelect.val() as string) : null,
                customReward,
                conditions,
            };

            this.context.naja.makeRequest('POST', this.options.url, JSON.stringify(data));
        });
    }

}